import { render, staticRenderFns } from "./Edition2026.vue?vue&type=template&id=88093cac&scoped=true&"
import script from "./Edition2026.vue?vue&type=script&lang=js&"
export * from "./Edition2026.vue?vue&type=script&lang=js&"
import style0 from "./Edition2026.vue?vue&type=style&index=0&id=88093cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88093cac",
  null
  
)

export default component.exports